import { useTranslation } from 'react-i18next'
import React from 'react'

import { useRowActionsColumn } from '../../../../../components/tables/Table'
import { useConfig } from '../_load/ConfigsLoader'
import { RefetchingIndicator } from '../../../../../packages/kiti/components/helpers/StatePresenter'
import SwitchDisabled from '../../../../../components/helpers/disabled/SwitchDisabled'
import { useConfigsActions } from '../../../_actions/configsActions'
import DataTable from '../../../../../packages/kiti/components/table/DataTable'
import { generalClient } from '../../../../../utils/apollo/api'
import { formatDate } from '@btime/helpers'
import { Bold, Span } from '../../../../../packages/kiti/components/presentation/Text'
import { COLORS } from '@btime/constants'

const ConfigsTable = () => {
  const { t } = useTranslation()

  const data = useConfig()

  const columns = [
    {
      label: `Nome `,
      headerSideContent: (
        <>
          <RefetchingIndicator />
        </>
      ),
      flex: 3,
      render: (item, record) => (
        <>
          <Bold color={COLORS.dark2} breakWord>
            Configuração{' '}
          </Bold>
          <Span strong color={COLORS.dark2} breakWord>
            {`${item.value?.label ? `${item.value?.label} - ` : ''} ${item.value?.conditions?.placeLevel?.name ?? ''}`}
          </Span>
        </>
      )
    },

    {
      label: 'Criado em',
      dataIndex: 'insertedAt',
      sortIndex: 'INSERTED_AT',
      flex: 2,
      format: formatDate('DD/MM/YYYY HH:mm')
    },

    {
      label: t('actions'),
      width: 3,
      render: useRowActionsColumn(useConfigsActions)
    }
  ]

  return <DataTable rowKey="id" columns={columns} size="medium" inPanel data={data} />
}

export default ConfigsTable
